<style lang="scss">
.panel-fbb {
	border: 1px solid #4b8df8;
	header {
		background-color: #4b8df8;
	}
}
</style>


<template>
	<div class="panel-main panel-fbb">
		<div v-if="lang=='en'">
			<h3>
				<Icon type="ios-car" size="16"></Icon>FBB System
			</h3>
			<article>
				<a target="_blank" :href="getUrl" class="panel-icon">
					<img src="../../image/icon_dbss.png" alt />
				</a>
				<div class="fbb-article">
					<a target="_blank" :href="getUrl" class="panel-title">Warehousing logistics platform</a>
					<p>
						Warehousing logistics platform can control all types of warehouses accurately and provide perfect solutions for overseas shipping and transit.
						It support self-employed, overseas, third-party and other types of warehouses, it has perfect storage, transfer, transloading and unsellable management and other functions and can provide average cost calculation function of receipts
					</p>
					<a target="_blank" :href="getUrl">
						<Button type="primary" size="large">
							Enter
							<Icon type="arrow-right-c"></Icon>
						</Button>
					</a>
				</div>
			</article>
		</div>
		<div v-else>
			<h3>
				<Icon type="android-bus" size="16"></Icon>仓储物流系统
			</h3>
			<article>
				<a target="_blank" :href="getUrl" class="panel-icon">
					<img src="../../image/icon_dbss.png" alt />
				</a>
				<div class="fbb-article">
					<a target="_blank" :href="getUrl" class="panel-title">仓储物流平台</a>
					<p>
						仓储物流平台能够精准控制各类仓库，完美解决海外仓发货及中转。
						<br />支持自营，海外，第三方托管等多类型仓库，完善的出入库、调拔、中转及故障品管理等功能，提供入库各环节的平均成本核算功能。
					</p>
					<a target="_blank" :href="getUrl">
						<Button type="primary" size="large">
							进入
							<Icon type="arrow-right-c"></Icon>
						</Button>
					</a>
				</div>
			</article>
		</div>
	</div>
</template>


<script>
import { mapState } from 'vuex';
export default {
	computed: {
		...mapState(['lang']),
		getUrl() {
			return  this.handleHostname(`https://${global.envPrefix}fb.onepinnovate.com`);
		}
	}
};
</script>
